export const sortNum = (arr = []) => arr?.sort((a, b) => a.sort - b.sort);
export const sortLinkNum = (arr = []) =>
  arr?.sort((a, b) => a.link_sort - b.link_sort);
